import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="ft">
      {/* Main footer */}
      <div className="ft-main">
        <div className="container">
          <div className="ft-grid">
            {/* Brand */}
            <div className="ft-brand">
              <Link to="/" className="ft-logo">
                <img src="/images/logofavblanc.png" alt="DOMOELEC" />
                <span><span className="hdr-green">D</span>OMO<span className="hdr-green">E</span>LEC</span>
              </Link>
              <p>Solutions professionnelles en courant faible : détection incendie, éclairage de sécurité, contrôle d'accès et onduleurs.</p>
              <div className="ft-socials">
                <a href="https://www.linkedin.com/company/domoelecsarl/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                  <i className="fab fa-linkedin-in"></i>
                </a>
              </div>
            </div>

            {/* Links */}
            <div className="ft-col">
              <h4>Navigation</h4>
              <ul>
                <li><Link to="/">Accueil</Link></li>
                <li><Link to="/domoelec">À propos</Link></li>
                <li><Link to="/produits">Produits</Link></li>
                <li><Link to="/services">Services</Link></li>
                <li><Link to="/contact">Contact</Link></li>
              </ul>
            </div>

            {/* Services */}
            <div className="ft-col">
              <h4>Services</h4>
              <ul>
                <li><Link to="/services#installation">Installation</Link></li>
                <li><Link to="/services#maintenance">Maintenance</Link></li>
                <li><Link to="/services#controle">Contrôle & Vérification</Link></li>
                <li><Link to="/services#conseil">Conseil & Études</Link></li>
              </ul>
            </div>

            {/* Contact */}
            <div className="ft-col">
              <h4>Contact</h4>
              <ul className="ft-contact">
                <li>
                  <i className="fas fa-phone-alt"></i>
                  <a href="tel:0522340659">05 22 34 06 59</a>
                </li>
                <li>
                  <i className="fas fa-envelope"></i>
                  <a href="mailto:contact@domoelec.ma">contact@domoelec.ma</a>
                </li>
                <li>
                  <i className="fas fa-map-marker-alt"></i>
                  <span>47 Rue Des Orangers, Mag Res Eden Tower, Ain Sebaa - Casablanca</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="ft-bottom">
        <div className="container">
          <div className="ft-bottom-inner">
            <p>© {new Date().getFullYear()} DOMOELEC. Tous droits réservés.</p>
            <div className="ft-bottom-links">
              <Link to="/mentions-legales">Mentions légales</Link>
              <span className="ft-dot"></span>
              <Link to="/politique-confidentialite">Confidentialité</Link>
            </div>
            <p className="ft-credit">Design by <strong>3SPROTECH</strong></p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
